import moment from "moment";
import { Snap } from "../../Models/Snap";
import { IOnlineStorage } from "../IOnlineStorage";
import { ISnapsOnlineStorage } from "./ISnapsOnlineStorage";
import { ClientInfoProvider } from "./ClientInfoProvider";


export class SnapsOnlineStorage implements ISnapsOnlineStorage
{
    constructor(
        private _onlineStorage: IOnlineStorage,
        private _watcherIdProvider: ClientInfoProvider,
        private password: string)
    { }

    public get UniqueClientId(): string
    {
        return this._watcherIdProvider.ClientId;
    }

    public get Password(): string
    {
        // Remove numbers from password to prevent password discovery and add random string 
        return this.password.substring(0, this.password.length - 3) + this._watcherIdProvider.ClientId;
    }

    public get Link(): string
    {
        return this._onlineStorage.Url + '/' + this.Password;
    }

    public async Add(snap: Snap): Promise<boolean>
    {
        const folder = this.Password;

        const fileName = moment(snap.Picture.PictureTime).format("YYYY_MM_DD__HH_mm_ss");

        return await this._onlineStorage.SaveBlob(snap.Picture, fileName + ".jpg", folder);
    }
}
